import * as yup from 'yup'

/**
 * The label the panel sends alongside a Persian translation.
 *
 * It is an English COUNTRY name doing the job of a language key, and the BFF matches the same
 * literal to pull the value back out. Naming it once here is the closest this side can get to a
 * shared contract without a schema change — if the two ever drift, the form passes and the
 * server rejects, which is the failure this whole rule exists to remove.
 */
export const FA_TRANSLATION_LABEL = 'Iran, Islamic Republic of'

/**
 * Requires a non-empty Persian translation in a `*TranslatedList`.
 *
 * The asset service requires a Persian name on all six accommodation / room type / rate plan
 * write paths and a short name on both channel paths, and answers a missing one with
 * `rpc error: ... NameFA: NameFA field is required` — a backend field name matching no label on
 * any of these screens. Reported as "it wants a Persian name but there is no field for one".
 *
 * Deliberately NOT `.of(object({ value: required() }))`, which is what two of these forms used:
 *
 *   - it passes when the list is EMPTY, since `.of()` validates the entries that exist
 *   - it passes on "   ", since yup's required() only rejects undefined, null and ""
 *
 * Both of those reach the server and fail there instead. The second is worse than it looks: the
 * asset service compares against "" without trimming too, so a whitespace name used to be
 * accepted end to end and create a record with a blank title.
 */
export const persianTranslationRequired = (
  message = 'This field is required'
) =>
  yup
    .array()
    // .nullable() so a null value reaches the test below and produces THIS message. Without it
    // yup raises its own type error first and the field shows "list must be a `array` type, but
    // the final value was: `null`" — a developer-facing string, on a form, to an operator.
    .nullable()
    .test(
      'persian-translation-present',
      message,
      (list) =>
        Array.isArray(list) &&
        list.some(
          (item) =>
            item?.label === FA_TRANSLATION_LABEL &&
            typeof item?.value === 'string' &&
            item.value.trim() !== ''
        )
    )
